import { render, staticRenderFns } from "./InstallTags.vue?vue&type=template&id=7772ed84&scoped=true"
import script from "./InstallTags.vue?vue&type=script&lang=js"
export * from "./InstallTags.vue?vue&type=script&lang=js"
import style0 from "./InstallTags.vue?vue&type=style&index=0&id=7772ed84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7772ed84",
  null
  
)

export default component.exports